































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitBaseData, UnitPositionData } from '@/api/heritageUnit/unitBase'
import UnitPositionsView from './positions.vue'
// import PointInMap from '@/components/pointInMap.vue'

@Component({
  components: {
    UnitPositionsView
    // , PointInMap
  }
})
export default class UnitBaseView extends Vue {
  public name = 'UnitBaseView'
  public expandNames: string[] = ['base']
  @Prop({ default: null })
  public formData!: UnitBaseData
  @Prop({ default: false })
  public loading: boolean = false

  public $refs!: {
    // refPointMap: PointInMap
  }
  get form(): UnitBaseData {
    var form = this.formData
    return form
  }

  public openMap() {
    let points: { id: number, name: string, lng: number, lat: number, category: number }[] = []
    points = this.form.PositionList.map((p: UnitPositionData) => {
      return {
        id: p.Id, name: p.PositionName,
        lng: p.HeritageLongitude, lat: p.HeritageLatitude,
        category: p.PositionType
      }
    })
    const data: { points: UnitPositionData[], unitId: number, mapTitle: string } = {
      points: this.form.PositionList,
      unitId: this.form.Id,
      mapTitle: this.form.HeritageName
    }
    window.eventBus.$emit('openUnitCoordPreview', data)
  }
}
